import { jsbSupportMap, openWebview, addNABackToWebviewEvent } from '@q-front-npm/jsbridge';
export const useLowVersionRefreshToken = async(uid: string) => {
    if (jsbSupportMap.app.header) {
        return;
    }
    const storageKey = 'lowVersionTokenUid';
    const cacheUid = localStorage.getItem(storageKey);
    // if (!cacheUid) {
    //     localStorage.setItem(storageKey, uid);
    //     return;
    // }
    if (cacheUid === uid) {
        return;
    }
    // 跳转中间页重刷cookie
    // 监听页面回显，刷新页面
    localStorage.setItem(storageKey, uid);
    addNABackToWebviewEvent((type: string) => {
        if (type === 'resume') {
            window.location.reload();
        }
    });
    openWebview(`https://xiaoshuo.wtzw.com/app-h5/activity/freereaderCommonLogin?full_screen=3`);
};
